<template>
  <div id="app">
    <!-- <ScrollbarContainer ref="scrollbarRef"
          height="100%"
          class="scroll-container"> -->
    <router-view />
    <!-- </ScrollbarContainer> -->
  </div>
</template>

<script>
import Head from './components/Header.vue'
import { HappyScroll } from 'vue-happy-scroll'
import 'vue-happy-scroll/docs/happy-scroll.css'

import ScrollbarContainer from '@/components/scrollbar/index.vue'
export default {
  components: { 'happy-scroll': HappyScroll, ScrollbarContainer },
  name: 'App',
  data() {
    return {

    }
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'margin: 0px;')
  },
}
</script>

<style>
@import '../static/siyuan/font.css';

/*里面的代码可以根据自己需求去进行更改*/
/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 12px !important;

}

/* 滚动槽 */
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3) !important;
  border-radius: 10px !important;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 10px !important;
  background: rgba(0, 0, 0, 0.1) !important;
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5) !important;
}

::-webkit-scrollbar-thumb:window-inactive {}

#app {
  width: 100%;
  padding: 0;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue